import {GA4ProductConfig} from '../../../shared/services/google-analytics-events.service';
import {StepKey} from '../../enums/step-key.enum';
import {Ga4EventPaymentType} from '../../consts/ga4-event-payment-type.enum';
import {Ga4EventName} from '../../consts/ga4-event-name.enum';
import {PaymentMethod} from '../../consts/payment-method.enum';

export const PRODUCT_CONFIG: GA4ProductConfig = {
    productName: 'moto',
    stepsMapping: [
        {
            stepKey: StepKey.FIRST_STEP_0,
            eventStepName: '0',
        },
        {
            stepKey: StepKey.FIRST_STEP_1,
            eventStepName: '1a',
        },
        {
            stepKey: StepKey.FIRST_STEP_2,
            eventStepName: '1b',
        },
        {
            stepKey: StepKey.FIRST_STEP_3,
            eventStepName: '1c',
        },
        {
            stepKey: StepKey.SECOND_STEP,
            eventStepName: '2',
        },
        {
            stepKey: StepKey.THIRD_STEP,
            eventStepName: '3',
        }
    ],
    paymentMethods: [
        {
            method: PaymentMethod.BLIK_ONLINE,
            eventPaymentType: Ga4EventPaymentType.BLIK_ONLINE,
            eventName: Ga4EventName.CLICK_PAYMENT_ONLINE
        },
        {
            method: PaymentMethod.CARD,
            eventPaymentType: Ga4EventPaymentType.CARD,
            eventName: Ga4EventName.CLICK_PAYMENT_CARD
        },
        {
            method: PaymentMethod.STANDARD_TRANSFER,
            eventPaymentType: Ga4EventPaymentType.STANDARD_TRANSFER,
            eventName: Ga4EventName.CLICK_PAYMENT_OFFLINE
        },
        {
            method: PaymentMethod.MPAY,
            eventPaymentType: Ga4EventPaymentType.PARTNER,
            eventName: Ga4EventName.CLICK_PAYMENT_PARTNER
        },
        {
            method: PaymentMethod.SKYCASH,
            eventPaymentType: Ga4EventPaymentType.PARTNER,
            eventName: Ga4EventName.CLICK_PAYMENT_PARTNER
        }
    ]
};
